<div class="titleSection">
    {{title | translate}}
</div>

